import React from "react";
import {
  Navbar,
  MobileNav,
  Typography,
  Button,
  IconButton,
  Card,
  Drawer,
} from "@material-tailwind/react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../img/logo.png";

import { AiOutlineMenu, AiOutlineClose } from "react-icons/ai";

const Header = () => {
  const [openNav, setOpenNav] = React.useState(false);
  const [openRight, setOpenRight] = React.useState(false);
  const navigate = useNavigate();

  const openDrawerRight = () => setOpenRight(true);
  const closeDrawerRight = () => setOpenRight(false);

  React.useEffect(() => {
    window.addEventListener(
      "resize",
      () => window.innerWidth >= 960 && setOpenNav(false)
    );
  }, []);

  const navList = (
    <ul className="mt-2 flex flex-col gap-2 lg:mb-0 lg:mt-0 lg:flex-row lg:items-center lg:gap-0 overflow-y-scroll lg:overflow-hidden max-h-96 lg:max-h-auto">
      <Link
        
        to={"/"}
        className="flex items-center text-white"
      >
        <img src={Logo} className="w-[210px] my-2 lg:block hidden" srcset="" />
      </Link>
      <Link
        
        to={"/"}
        className="flex items-center text-white"
      >
        <Typography
          as="li"
          variant="lg"
          className="p-8 py-8 font-bold font-bold"
        >
          Home
        </Typography>
      </Link>
      <Link
        to={"/about"}
        
        className="flex items-center hover:text-black-900 text-white font-bold hover:text-[#003090]"
      >
        <Typography as="li" variant="lg" className="p-8 py-8 font-bold ">
          About
        </Typography>
      </Link>
      <Link
        to={"/gallery"}
        
        className="flex items-center hover:text-black-900 text-white font-bold hover:text-[#003090]"
      >
        <Typography as="li" variant="lg" className="p-8 py-8 font-bold ">
          Gallery
        </Typography>
      </Link>
      <Link
        to={"/services"}
        
        className="flex items-center hover:text-black-900 text-white font-bold hover:text-[#003090]"
      >
        <Typography as="li" variant="lg" className="p-8 py-8 font-bold ">
          Services
        </Typography>
      </Link>
      <Link
        to={"/contact"}
        
        className="flex items-center hover:text-black-900 text-white font-bold hover:text-[#003090]"
      >
        <Typography as="li" variant="lg" className="p-8 py-8 font-bold ">
          Contact
        </Typography>
      </Link>
    </ul>
  );

  const navListLg = (
    <ul className="mt-2 flex flex-col gap-2 lg:mb-0 lg:mt-0 lg:flex-row lg:items-center lg:gap-0">
      <Link to={"/"} className="flex items-center text-black-900">
        <Typography
          as="li"
          variant="lg"
          className="p-8 py-8 font-bold bg-[#003090] font-bold"
        >
          Home
        </Typography>
      </Link>
      <Link
        to={"/about"}
        className="flex items-center hovertext-black-900 text-white font-bold hover:bg-[#003090]"
      >
        <Typography as="li" variant="lg" className="p-8 py-8 font-bold ">
          About
        </Typography>
      </Link>
      <Link
        to={"/gallery"}
        className="flex items-center hovertext-black-900 text-white font-bold hover:bg-[#003090]"
      >
        <Typography as="li" variant="lg" className="p-8 py-8 font-bold ">
          Gallery
        </Typography>
      </Link>
      <Link
        to={"/services"}
        className="flex items-center hovertext-black-900 text-white font-bold hover:bg-[#003090]"
      >
        <Typography as="li" variant="lg" className="p-8 py-8 font-bold ">
          Services
        </Typography>
      </Link>
      <Link
        to={"/contact"}
        className="flex items-center hovertext-black-900 text-white font-bold hover:bg-[#003090]"
      >
        <Typography as="li" variant="lg" className="p-8 py-8 font-bold ">
          Contact
        </Typography>
      </Link>
    </ul>
  );
  return (
    <>
      <Drawer
        placement="right"
        open={openRight}
        onClose={closeDrawerRight}
        className="p-4 bg-[#333333] "
      >
        <div className="mb-6 flex items-center justify-between">
          <Typography variant="h5" color="white">
            The Best Roofing Contracting
          </Typography>
          <IconButton
            variant="text"
            color="blue-gray"
            onClick={closeDrawerRight}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
              className="h-5 w-5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </IconButton>
        </div>
        <ul>
          <li className="p-4" >
            <Link className="text-white" onClick={closeDrawerRight} to={"/"}>Home</Link>
          </li>
          <li className="p-4" >
            <Link className="text-white" onClick={closeDrawerRight} to={"/about"}>About</Link>
          </li>
          <li className="p-4" >
            <Link className="text-white" onClick={closeDrawerRight} to={"/services"}>Services</Link>
          </li>
          <li className="p-4" >
            <Link className="text-white" onClick={closeDrawerRight} to={"/gallery"}>Gallery</Link>
          </li>
          <li className="p-4" >
            <Link className="text-white" onClick={closeDrawerRight} to={"/contact"}>Contact</Link>
          </li>
        </ul>
      </Drawer>
      <Navbar className="lg:sticky inset-0 z-10 h-max max-w-full rounded-none border-none px-4 lg:px-32 lg:py-0 lg:bg-[#000000] bg-[url('https://i.pinimg.com/736x/c8/9d/3f/c89d3ff27144b0d51e6f954a54ada718--exterior-colors-exterior-paint.jpg')]">
        <marquee className="lg:hidden w-full block py-2 pb-4 px-12 bg-[#003090]">
          <em className="text-white"> The Best Roofing Contracting | </em>
          <i className="fa fa-flag-o"></i>{" "}
          <span className="text-white">
            {" "}
            Kentucky, North Carolina |{" "}
          </span>
          <i className="fa fa-flag-o"></i>{" "}
          <span className="text-white"> 15 years of Experience | </span>{" "}
          <i className="fa fa-flag-o"></i>{" "}
          <span className="text-white"> thebestroofing7@gmail.com | </span>
          <i className="fa fa-flag-o"></i>{" "}
          <span className="text-white"> Free Estimates | </span>
        </marquee>
        <Link
          onClick={() => setOpenRight(!openRight)}
          to={"/"}
          className="flex items-center text-white lg:hidden block"
        >
          <img src={Logo} className="w-[380px] my-2" srcset="" />
        </Link>
        <div className="flex items-center justify-between text-blue-gray-900">
          <div className="flex w-screen items-center gap-4">
            <div className=" hidden lg:block">{navList}</div>
            <IconButton
              variant="text"
              className="ml-[50%] my-8 flex h-8 w-full text-inherit hover:bg-transparent focus:bg-transparent active:bg-transparent lg:hidden"
              ripple={false}
              onClick={() => setOpenRight(!openRight)}
            >
              {openRight ? (
                <div className="bg-[#FF0006]">
                  <AiOutlineClose className="text-white text-xl" />
                </div>
              ) : (
                <div className="bg-[#FF0006] p-4">
                  <AiOutlineMenu className="text-white text-xl" />
                </div>
              )}
            </IconButton>
          </div>
        </div>
        <div className="lg:hidden block">
          <MobileNav open={openNav}>{navList}</MobileNav>
        </div>

        {/* <div className="lg:block hidden">
          <MobileNav open={openNav}>{navListLg}</MobileNav>
        </div> */}
      </Navbar>
    </>
  );
};

export default Header;
